import React, { useContext } from 'react';
import InputConfig from '../../../../Components/InputConfig';
import { Grid } from '@mui/material';
import useStyles from './styles';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import { FvpConfigContext } from '../../../../Contexts/FvpConfigContext';
import { ACCESS_CONTROL_CONSTANTS } from '../../../../core/constants';
import SwitchInput from '../../../../Components/SwitchInput';
import PageHeading from '../../../../Components/PageHeading';
import useCommonStyles from '../../../../commonStyles';

const { SYSTEMS } = ACCESS_CONTROL_CONSTANTS;

/**
 * @name UamConfigSettings
 * @description This component is an editor for the networkData UamConfig configuration.
 *
 * networkData: {
 *	uamConfig: {
 *		enabled: false,
 *		publisherId: '2e7e1587-d92f-46dd-8721-80b53eccb87e',
 *		uamSlotId: 'Adpushup_Instream'
 *	}
 *}
 *
 * @param {{keyData: 'networkData.uamConfig'}} keyData - A keyData used to identify the configuration in the rawConfig object.
 */
const UamConfigSettings = ({ keyData }) => {
	const classes = useStyles();
	const { rawConfig, updateRawConfig } = useContext(FvpConfigContext);
	const commonStyleClasses = useCommonStyles();
	return (
		<Paper className={commonStyleClasses.mainPagePaperMarginStyle}>
			<PageHeading
				headingName="Uam Config"
				headingPath={['Dashboard', 'Fvp', 'Network Data', 'Uam Config']}
				description="Manage Uam configurations here."
			/>

			<Grid
				container
				spacing={1}
				style={{ height: '60%', width: '90%', marginLeft: '4rem', marginTop: '3rem' }}
			>
				<Grid item xs={3} style={{ marginTop: '5rem' }}>
					<SwitchInput
						system={SYSTEMS.FVP_PLAYER}
						keyData={keyData + '.enabled'}
						label="Enabled"
						disabled={false}
						defaultChecked={false}
						object={rawConfig}
						updateObject={updateRawConfig}
					/>
				</Grid>
				<Grid item xs={4}>
					<InputConfig
						system={SYSTEMS.FVP_PLAYER}
						label="Publisher Id"
						keyData={keyData + '.publisherId'}
						object={rawConfig}
						updateObject={updateRawConfig}
					/>
				</Grid>
				<Grid item xs={4}>
					<InputConfig
						system={SYSTEMS.FVP_PLAYER}
						label="uamSlot Id"
						keyData={keyData + '.uamSlotId'}
						object={rawConfig}
						updateObject={updateRawConfig}
					/>
				</Grid>
			</Grid>
		</Paper>
	);
};

export default UamConfigSettings;